@if ((loaderService.loading$ | async) && (loaderService.overlay$ | async)) {
<div class="overlay">
    <span class="loader"></span>
</div>
}